import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { authApi } from '../api/auth'
import AuthShell from '../components/AuthShell'
import { inputCls, labelCls, primaryBtn } from '../components/form'

export default function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password !== confirm) { setError('비밀번호가 일치하지 않습니다.'); return }
    setError('')
    setLoading(true)
    try {
      await authApi.resetPassword(token, password)
      navigate('/login')
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { error?: string } } })?.response?.data?.error
      setError(msg || '비밀번호 재설정에 실패했습니다. 링크가 만료되었을 수 있습니다.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell
      title="새 비밀번호 설정"
      footer={<Link to="/forgot-password" className="text-gray-500 hover:text-gray-900 transition-colors">재설정 링크 다시 요청</Link>}>
      {token ? (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="rp-pw" className={labelCls}>새 비밀번호</label>
            <input id="rp-pw" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)}
              required autoFocus className={inputCls} />
          </div>
          <div>
            <label htmlFor="rp-confirm" className={labelCls}>새 비밀번호 확인</label>
            <input id="rp-confirm" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              required className={inputCls} />
          </div>
          {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading} className={`w-full ${primaryBtn} py-2.5`}>
            {loading ? '변경하는 중…' : '비밀번호 변경'}
          </button>
        </form>
      ) : (
        <p className="text-sm text-gray-700 leading-relaxed">
          재설정 링크가 올바르지 않습니다. 메일의 링크를 다시 확인하거나 재설정을 다시 요청하세요.
        </p>
      )}
    </AuthShell>
  )
}
